import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { SearchParams } from '../../../core/model';
import { LastMostOrderedArticleType } from '../model';
import { ORDER_CORE_FEATURE } from '../store/order-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: LastMostOrderedArticlesFacade,
      feature: ORDER_CORE_FEATURE,
      async: true,
      methods: [
        'getLastMostOrderedArticleRefs',
        'getLastMostOrderedArticlesLoading',
        'getLastMostOrderedArticlesLoaded',
        'getLastMostOrderedArticlesTotalCount',
      ],
    }),
})
export abstract class LastMostOrderedArticlesFacade {
  abstract getLastMostOrderedArticleRefs(
    type: LastMostOrderedArticleType,
    searchParams?: SearchParams
  ): Observable<Array<string> | undefined>;
  abstract getLastMostOrderedArticlesLoading(type: LastMostOrderedArticleType): Observable<boolean>;
  abstract getLastMostOrderedArticlesLoaded(type: LastMostOrderedArticleType): Observable<boolean>;
  abstract getLastMostOrderedArticlesTotalCount(type: LastMostOrderedArticleType): Observable<number>;
}
